import { useEffect, useState } from "react";
import logo from "../../assets/images/logo-default.svg";
import * as API from "../../core/service/api_profile.js";
import { useDispatch } from "react-redux";
import { setLoading } from "../../core/feature/config/configSlice";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import Company from "../../core/models/company";

export const ConfirmationVerifyDesktop = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const location: any = useLocation();
  const navigate = useNavigate();

  const [accounts, setAccounts] = useState<any>([]);
  const [user, setUser] = useState<any>(null);
  const [isMyAccount, setIsMyAccount] = useState(false);
  const [company, setCompany] = useState<Company>({} as Company);

  useEffect(() => {
    if (location.state && location.state.accounts) {
      setAccounts(location.state.accounts);
    }
    if (location.state && location.state.user) {
      setUser(location.state.user);
    }
  }, [location.state]);

  useEffect(() => {
    if (localStorage.getItem("company")) {
      const companyData = JSON.parse(localStorage.getItem("company") || "{}");
      setCompany(companyData);
    }
  }, []);

  const handleMerge = async () => {
    const data = {
      id: accounts[0]?.id,
      callerName: user.accounts[0].callerIdentities[0].name,
      callerId: user.accounts[0].callerIdentities[0].callerId,
      email: location.state?.email,
      phone: location.state?.phone,
      companyName: company.name,
    };
    dispatch(setLoading(true));
    try {
      const res = await API.mergeAccount(data, accounts[0]?.id);
      localStorage.setItem("merged", JSON.stringify(res));
      dispatch(setLoading(false));
      navigate("otp", {
        replace: true,
        state: {
          email: location.state?.email,
          phone: location.state?.phone,
        },
      });
    } catch (error) {
      console.error("Error merging account:", error);
      dispatch(setLoading(false));
    }
  };

  return (
    <div className="min-h-screen w-full bg-psp-primary flex items-center justify-center p-6 font-montserrat">
      <div className="w-full max-w-[520px] rounded-2xl bg-white shadow-lg p-8">
        <div className="flex justify-center">
          <img src={logo} className="w-52 select-none" alt="PSP" />
        </div>

        <div className="mt-8 flex flex-col">
          <p className="font-semibold text-lg text-primary">
            {t("CONFIRMATIONVERIFY.title")}
          </p>
          <p className="font-medium text-sm mt-1">
            {t("CONFIRMATIONVERIFY.subtitle")}
          </p>

          <div className="bg-amber-100 rounded-md w-full mt-4 flex flex-row gap-2 items-center p-2">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="w-8 h-8 shrink-0 text-amber-900"
            >
              <circle cx="12" cy="12" r="10"></circle>
              <line x1="12" y1="8" x2="12" y2="12"></line>
              <line x1="12" y1="16" x2="12.01" y2="16"></line>
            </svg>
            <div className="text-sm text-amber-900">
              {t("CONFIRMATIONVERIFY.security_warning")}
            </div>
          </div>

          <div className="bg-[#F7F8FD] border border-[#E5E7EB] rounded-md w-full p-4 text-sm mt-4 flex flex-col gap-2">
            <div className="flex flex-row justify-between items-center gap-4">
              <div className="text-[#6B7280]">Name</div>
              <div className="font-medium text-right">
                {accounts[0]?.callerName || "N/A"}
              </div>
            </div>
            <div className="flex flex-row justify-between items-center gap-4">
              <div className="text-[#6B7280]">Sekolah</div>
              <div className="text-right">
                {accounts[0]?.companyName || "N/A"}
              </div>
            </div>
            <div className="flex flex-row justify-between items-center gap-4">
              <div className="text-[#6B7280]">email</div>
              <div className="text-right break-all">
                {accounts[0]?.email || "N/A"}
              </div>
            </div>
            <div className="flex flex-row justify-between items-center gap-4">
              <div className="text-[#6B7280]">WhatApp</div>
              <div className="text-right">{accounts[0]?.phone || "N/A"}</div>
            </div>
          </div>

          <label
            htmlFor="isMyAccountDesktop"
            className="flex items-center gap-2 mt-4 text-sm cursor-pointer"
          >
            <input
              id="isMyAccountDesktop"
              type="checkbox"
              checked={isMyAccount}
              onChange={() => setIsMyAccount(!isMyAccount)}
            />
            {t("CONFIRMATIONVERIFY.checkbox_label")}
          </label>

          <div className="flex flex-col gap-2 mt-8">
            <button
              onClick={() => handleMerge()}
              className="py-2 w-full bg-psp-btn-primary text-white rounded-md font-semibold font-poppins text-sm min-h-[5vh] hover:bg-blue-800 disabled:opacity-50 disabled:cursor-not-allowed"
              disabled={!isMyAccount}
            >
              {t("CONFIRMATIONVERIFY.buttons.submit")}
            </button>
            <button
              type="button"
              onClick={() => navigate(-1)}
              className="py-2 w-full border-2 border-psp-primary text-psp-primary rounded-md font-semibold font-poppins text-sm min-h-[5vh] hover:bg-blue-50"
            >
              {t("CONFIRMATIONVERIFY.buttons.cancel")}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
